import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionCadastro = ({dispatch},payload)=>{
    return serves.tabelaprecorublicaevento.cadastra(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionMover = ({dispatch},payload)=>{
    return serves.tabelapreco.mover(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionLista = ({dispatch},payload)=>{
    return serves.tabelaprecorublicaevento.lista(payload).then(res => {
        dispatch('ActionSetLista',res)
    }).catch(err => {
        dispatch('ActionSetLista',res)
    })
}
export const ActionPesquisa = ({dispatch},payload)=>{
    return serves.tabelaprecorublicaevento.pesquisa(payload).then(res => {
        dispatch('ActionSetPesquisa',res)
    }).catch(err => {
        dispatch('ActionSetPesquisa',res)
    })
}
export const ActionDeletar = ({dispatch},payload)=>{
    return serves.tabelaprecorublicaevento.delete(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',res)
    })
}
export const ActionEditar = ({dispatch},payload)=>{
    return serves.tabelaprecorublicaevento.editar(payload).then(res => {
        dispatch('ActionSetEditar',res)
    }).catch(err => {
        dispatch('ActionSetEditar',err)
    })
}
export const ActionUpdate = ({dispatch},payload)=>{
    return serves.tabelaprecorublicaevento.update(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionConfiguracaoCartaoPonto = ({dispatch},payload)=>{
    return serves.tabelapreco.configuracaocartaoponto(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',res)
    })
}
export const ActionRublicas = ({dispatch},payload)=>{
    return serves.tabelaprecorublicaevento.rublica(payload).then(res => {
        dispatch('ActionSetRublicas',res)
    }).catch(err => {
        dispatch('ActionSetRublicas',res)
    })
}
export const ActionSetLista = ({commit},payload) =>{
    commit(types.SET_LISTA,payload)
}
export const ActionSetMsg = ({commit},payload) =>{
    commit(types.SET_MSG,payload)
}
export const ActionSetEditar = ({commit},payload) =>{
    commit(types.SET_EDITAR,payload)
}
export const ActionSetPesquisa = ({commit},payload) =>{
    commit(types.SET_PESQUISA,payload)
}
export const ActionSetRublicas = ({commit},payload) =>{
    commit(types.SET_RUBLICA,payload)
}
